import { gql } from "@apollo/client";

export const GET_SERVICE_FEES = gql`
  query getServiceFeeConfig {
    getServiceFeeConfig {
      cardFeePercent
      cardFeeAdderCents
      platformFeePercent
    }
  }
`;
